import { Box } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

const AnnotationThumbnailIcon = (props: SvgIconProps) => {
  return (
    <Box sx={{ width: '100px', height: '54px', flexShrink: 0, position: 'relative' }}>
      <svg width="100" height="54" viewBox="0 0 100 54">
        <defs>
          <style>
            {`
                        :root {
                            --Elevation-06dp: #333539;
                        }
                        `}
          </style>
        </defs>

        <rect
          x="0.5"
          y="0.5"
          width="99"
          height="53"
          rx="4"
          fill="var(--Elevation-06dp, #333539)"
          stroke="#6B7280"
          strokeWidth="1"
          strokeDasharray="2 2"
        />

        <circle cx="50" cy="27" r="13.5" fill="var(--Elevation-06dp, #333539)" stroke="#6B7280" strokeWidth="0.75" />
      </svg>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            width: '27px',
            height: '27px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#FFF',
            fontFamily: '"Open Sans"',
            fontSize: '12px',
            fontWeight: 700,
            lineHeight: '11px',
          }}
        >
          ?
        </Box>
      </Box>
    </Box>
  );
};

export default AnnotationThumbnailIcon;
